const u = (n, e, r) => r > 0 && r < n ? n : r > 0 && r > e || r > 0 && r > e ? e : r;
export {
  u as default
};
//# sourceMappingURL=getWidthInBoundaries.js.map
